export const SUCCESS_THEME_LIST = "SUCCESS_THEME_LIST";
export const LOADING_THEME_LIST = "LOADING_THEME_LIST";
